import { render, staticRenderFns } from "./DensitiesManager.vue?vue&type=template&id=e97a10d2&"
import script from "./DensitiesManager.vue?vue&type=script&lang=ts&"
export * from "./DensitiesManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports